export const PRIVILEGE = {
    BRAND: {
        BRAND: {
            CREATE: 'brand.brand.create',
            EDIT: 'brand.brand.edit'
        }
    },
    HUB: {
        USER: {
            INDEX: 'hub.user.index',
            CREATE: 'hub.user.create',
            EDIT: 'hub.user.edit',
            DESTROY: 'hub.user.destroy'
        }
    },
    CAMPAIGN: {
        CAMPAIGN: {
            SHOW: 'campaign.campaign.show',
            EDIT: 'campaign.campaign.edit',
            CREATE: 'campaign.campaign.create'
        },
        APPLICATION: {
            PROCESS: 'campaign.application.process',
            INDEX: 'campaign.application.index'
        },
        COLLABORATION: {
            PROCESS: 'campaign.collaboration.process',
            INDEX: 'campaign.collaboration.index'
        },
        PERFORMANCE: {
            INDEX: 'campaign.performance.index'
        },
        PAYMENT : {
            INDEX: 'campaign.payment.index'
        }
    }
}